/**
 * Lets a screen that holds work only in memory (the register's open ticket)
 * say so, so pulling down to refresh asks first instead of wiping it. Queued
 * sales are stored on the device and survive a reload; an unpaid ticket does not.
 */
let isBusy = () => false;

export const setPullRefreshGuard = (fn) => {
  isBusy = typeof fn === "function" ? fn : () => false;
  return () => {
    isBusy = () => false;
  };
};

export const pullRefreshBusy = () => {
  try {
    return Boolean(isBusy());
  } catch {
    return false;
  }
};
